const EMAIL_CONSENT_CHANNEL_ID = 15;

export const reportEmailConsentToOptimove = (brandId: string | null, email: string | null, optIn: boolean): void => {
    if (brandId === null || email === null || typeof window === 'undefined') {
        return;
    }

    if (window.optimoveSDK?.API?.reportEvent) {
        window.optimoveSDK.API.reportEvent('consent', {
            opt_in: optIn,
            brand: brandId,
            event_origin: 'sdk',
            identifier: email,
            execution_method: 'email',
            channel_id: EMAIL_CONSENT_CHANNEL_ID,
        });
    }
};
